<div class="input-container">
  <label [for]="label">{{ label }}</label>
  <p-inputGroup [class.disabled]="disabled">
    <p-inputGroupAddon *ngIf="iconSrc">
      <img [src]="iconSrc" alt="icon" />
    </p-inputGroupAddon>
    <p-inputGroupAddon *ngIf="icon">
      <i [class]="icon"></i>
    </p-inputGroupAddon>
    <p-calendar
      [id]="label"
      [(ngModel)]="value"
      (onBlur)="onTouched()"
      [dateFormat]="dateFormat"
      [showTime]="showTime"
      [hourFormat]="hourFormat.toString()"
      [showIcon]="showIcon"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [ngClass]="getValidationNgClasses(control)"></p-calendar>
  </p-inputGroup>
  @if (description) {
    <small class="input-description">{{ description }}</small>
  }
  @if (control?.invalid && (control?.dirty || control?.touched)) {
    <div class="error-messages">
      @for (message of errorMessages; track $index) {
        <small class="input-error-message">{{ message }}</small>
      }
    </div>
  }
</div>
